<template>
    <div id="app">
        <meta charset="utf-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <router-view/>

        <BToast id="single-toast" :variant="toastInfo.variant"
                :auto-hide-delay="toastInfo.hide"
                solid
                toaster="b-toaster-bottom-center"
        >
            <template #toast-title>
                {{ toastInfo.title }}
            </template>
            {{ toastInfo.content }}
        </BToast>

        <b-toaster name="b-toaster-bottom-center" class="p-3"></b-toaster>
        <portal-target name="global-dropdown" multiple slim></portal-target>
    </div>
</template>

<script>
import { loginUrlWithRedirect, sessionChangeOf } from '@core_utils/common-logout';

export default {
    data() {
        return {
            toastInfo: {
                variant: 'info',
                hide: 2000,
                title: '',
                content: ''
            }
        };
    },
    methods: {
        makeToast(title, contents, append = false, hide = 2000, variant = 'success') {
            const toastContent = contents?.tag != null ? contents : `${contents}`;

            this.$bvToast.toast(toastContent, {
                title: title,
                toaster: 'b-toaster-bottom-center',
                solid: true,
                appendToast: append,
                // noAutoHide: true,
                autoHideDelay: hide,
                variant
            });
        },
        makeToastInfo(title, contents, append = false, hide = 2000) {
            this.makeToast(title, contents, append, hide, 'info');
        },
        makeToastFail(title, contents, append = false, hide = 8000) {
            const toastContent = contents?.tag != null ? contents : `${contents}`;

            this.$bvToast.toast(toastContent, {
                title: title,
                toaster: 'b-toaster-bottom-center',
                solid: true,
                appendToast: append,
                // noAutoHide: true,
                autoHideDelay: hide,
                variant: 'danger'
            });
        },
        makeToastWarning(title, contents, append = false, hide = 8000) {
            const toastContent = contents?.tag != null ? contents : `${contents}`;

            this.$bvToast.toast(toastContent, {
                title: title,
                toaster: 'b-toaster-bottom-center',
                solid: true,
                appendToast: append,
                autoHideDelay: hide,
                variant: 'warning'
            });
        },
        openSingleToast(info) {
            this.toastInfo.variant = info.variant || 'info';
            this.toastInfo.hide = info.hide || 2000;
            this.toastInfo.title = info.title || '';
            this.toastInfo.content = info.content || '';

            this.$bvToast.show('single-toast');
        },
        // 다른 탭의 로그아웃·계정 전환을 이 탭에 반영한다(공개 화면은 무관). 처리 중의 연속 이벤트는 한 번만 처리한다.
        onStorageChange(e) {
            if (this.sessionChangeHandled || !this.$route.matched.some(r => r.meta.requireAuth)) return;
            const change = sessionChangeOf(e, this.$store.state.user_id);
            if (change === 'logout') {
                this.leaveForSessionChange(() => window.location.replace(loginUrlWithRedirect()));
            } else if (change === 'switch') {
                this.sessionChangeHandled = true;
                const reload = () => this.leaveForSessionChange(() => window.location.reload());
                this.$showModal({
                    type: 'alert',
                    state: 'warning',
                    title: this.$t('로그인 정보 변경'),
                    message: this.$t('다른 탭에서 다른 계정으로 로그인해 이 화면을 새로 고칩니다.')
                }).then(reload, reload);
            }
        },
        // 이동·새로고침이 미저장 확인창에서 취소돼 이 페이지가 남으면 1초 뒤 다시 감지하도록 푼다
        leaveForSessionChange(go) {
            this.sessionChangeHandled = true;
            go();
            setTimeout(() => { this.sessionChangeHandled = false; }, 1000);
        },
        // 요청 인터셉터가 다른 탭의 계정 변경으로 쓰기 요청을 막았을 때의 안내 (연속 차단은 안내 하나로)
        onAccountChangedElsewhere() {
            if (this.accountChangedNoticeOpen) return;
            this.accountChangedNoticeOpen = true;
            const done = () => { this.accountChangedNoticeOpen = false; };
            this.$showModal({
                type: 'alert',
                state: 'warning',
                title: this.$t('로그인 정보 변경'),
                message: this.$t('다른 탭에서 계정이 바뀌었습니다. 새로고침 후 다시 시도해 주세요.')
            }).then(done, done);
        }
    },
    mounted() {
        window.EventBus.$on('toast-success', this.makeToast);
        window.EventBus.$on('toast-failure', this.makeToastFail);
        window.EventBus.$on('toast-warning', this.makeToastWarning);
        window.EventBus.$on('toast-info', this.makeToastInfo);

        this.$EventBus.$on('toast-success', this.makeToast);
        this.$EventBus.$on('toast-failure', this.makeToastFail);
        this.$EventBus.$on('toast-warning', this.makeToastWarning);
        this.$EventBus.$on('toast-info', this.makeToastInfo);
        this.$EventBus.$on('single-toast-on', this.openSingleToast);

        window.EventBus.$on('account-changed-elsewhere', this.onAccountChangedElsewhere);
        window.addEventListener('storage', this.onStorageChange);
    },
    beforeDestroy() {
        window.EventBus.$off('account-changed-elsewhere', this.onAccountChangedElsewhere);
        window.removeEventListener('storage', this.onStorageChange);
    }

};
</script>

<style>

</style>
